
import BetterScroll from "better-scroll"
import { Image } from "element-ui"
export default {
  components: {
    [Image.name]: Image
  },
  props: {
    coreData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      scroll: null,
      scrollWidth: 0,
      scrollDistance: 0,
      showAll: false
    }
  },
  computed: {
    showRightArrow() {
      return this.scrollDistance - 700 > -this.scrollWidth && this.scrollWidth > 700
    },
    showRightLeft() {
      return this.scrollDistance < 0
    }
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this.scrollWidth = this.$refs.offerList.scrollWidth
      // this.$refs.offerList.style.width = this.scrollWidth + 'px';
      this.scroll = new BetterScroll(this.$refs.scrollContent, {
        scrollX: true,
        click: true,
        probeType: 3,
        bounce: false
      })
    })
  },
  methods: {
    handleArrowLeft() {
      this.scrollDistance += 300
      this.scroll.scrollTo(this.scrollDistance, 0, 300)
    },
    handleArrowRight() {
      this.scrollDistance -= 300
      this.scroll.scrollTo(this.scrollDistance, 0, 300)
    }
  }
}
